import { render, staticRenderFns } from "./PT504GTMPurchase.vue?vue&type=template&id=b5c69cbe&"
import script from "./PT504GTMPurchase.vue?vue&type=script&lang=js&"
export * from "./PT504GTMPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports